export const testimonials = [
  {
    name: '张先生',
    location: '北京',
    rating: 5,
    content: '用了91免费推荐的看片软件快一年了，资源真的超全！想看的基本都能找到，而且完全不卡，比那些收费的视频网站好用多了。强烈推荐给喜欢看片的朋友！',
    date: '2026-07-15',
  },
  {
    name: '李女士',
    location: '上海',
    rating: 5,
    content: '之前找免费看片软件总是下载到带广告的，体验很不好。后来朋友介绍了91免费，推荐的软件确实干净好用，安装教程也很详细，小白也能轻松搞定。',
    date: '2026-07-10',
  },
  {
    name: '王同学',
    location: '广州',
    rating: 5,
    content: '作为一个影视爱好者，91免费简直是宝藏网站！不仅软件推荐靠谱，使用教程也写得很用心。现在看剧看电影都用这里的软件，省钱又好用。',
    date: '2026-06-28',
  },
  {
    name: '赵先生',
    location: '深圳',
    rating: 4,
    content: '91免费上面推荐的安卓看片软件质量很高，更新也及时。希望iOS端能再多推荐一些选择，有时候感觉苹果端的免费软件相对少一些。',
    date: '2026-07-02',
  },
  {
    name: '刘女士',
    location: '成都',
    rating: 5,
    content: '在91免费找到了适合我家电视盒子的看片软件，全家人都很喜欢！资源更新快，播放稳定，客服响应也很快。已经推荐给身边很多朋友了。',
    date: '2026-07-18',
  },
  {
    name: '陈先生',
    location: '杭州',
    rating: 5,
    content: '做影视剪辑工作需要大量看片参考，91免费推荐的软件帮我节省了大量时间。多源切换功能特别好用，一个源不行马上换另一个，基本不会断。',
    date: '2026-06-20',
  },
];